export default "__VITE_ASSET__BkR5Nsyc__"